export default __webpack_public_path__ + "static/6-6922f89e895810a864571d0a8bd71fba.png";